import { useEffect, useState, useCallback } from 'react';
import LayoutPage from "../../templates/Layout/LayoutPage";
import MaterialTable, { MTableToolbar } from '@material-table/core';
import axios from 'axios';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';
import Button from "@mui/material/Button";
import ReportButtons from "../../components/organisms/BugReport/ReportButtons";
import { useAuth0 } from "@auth0/auth0-react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import { TabsStyles } from "./Cruds.styles";
import { nameValidation } from 'src/utils/helpsers';

const CustomBoards = () => {
  const [boards, setBoards] = useState([]);
  const [iserror, setIserror] = useState(false);
  const [errorMessages, setErrorMessages] = useState([]);
  const [activeUser, setActiveUser] = useState([]);
  const [activeTab, setActiveTab] = useState('my_board');
  const [columns, setColumns] = useState([]);
  const [users, setUsers] = useState([]);
  const [userGroups, setUserGroups] = useState([]);

  const { user } = useAuth0();
  const enabledShare = user[`${process.env.REACT_APP_AUTH0_KEY}/district`].enable_share;

  let tabs = [
    { 'name': 'My Boards', 'value': 'my_board' },
    { 'name': 'Shared with me', 'value': 'shared_with' }
  ];

  if(!enabledShare) {
    tabs = tabs.filter(el => el.value !== "shared_with");
  }

  const defineColumns = useCallback((tab) => {
    if (tab === 'shared_with') {
      return [
        {
          title: 'Name', field: 'label', editable: 'never',
          render: props => {
            return (
              <a
                href={'/' + props.type.toLowerCase() + '?shared=' + props.uuid}
                target="_blank"
                rel="noopener noreferrer"
                className="btn form-submit"
              >
                {props.label}
              </a>
            );
          },
        },
        { title: 'Type', field: 'type', editable: 'never' },
        { title: 'Owner', field: 'created_by', editable: 'never' }
      ];
    }
    if (tab === 'my_board') {
      return [
        {
          title: 'Name', field: 'label',
          validate: rowData => {
            if (!rowData.label) {
              return 'Name cannot be blank';
            } else if((/^(\s)/g).test(rowData.label) || (/(\s)$/g).test(rowData.label)){
              return 'The name can not start or end with a white space'
            } else if((/[^\s]*\s{2,}/g).test(rowData.label)){
              return 'Do not group multiple white spaces'
            } else if (rowData.label.length < 3) {
              return 'Name must have at least three letters';
            }
            return true;
          },
          render: props => {
            return (
              <a
                href={'/' + props.type.toLowerCase() + '?shared=' + props.uuid}
                target="_blank"
                rel="noopener noreferrer"
                className="btn form-submit"
              >
                {props.label}
              </a>
            );
          },
        },
        { title: 'Type', field: 'type', editable: 'never' },
        {
          title: 'Shared with', field: 'available_users_share',
          render: props => {
            let available_users = [];

            if (props.available_users_share) {
              props.available_users_share.forEach(availableUser => {
                available_users.push(availableUser.label);
              })
            }

            const listUsers = available_users.map((available_user) =>
              <>
                <p>{available_user}</p>
                <Divider variant="fullWidth" />
              </>
            );

            return (
              listUsers
            );
          },
          editComponent: props => {
            let filteredUsers = users.filter((userF) => userF.group_id === activeUser.group_id ? userF : false);

            let usersFormat = filteredUsers.map((userF) => {
              let userGroup = userGroups.find(userGroup => userGroup.id === userF.group_id);
              return ({ 'value': userF.email, 'label': userF.name + ' @ ' + userGroup.name });
            });
            return (
              <Autocomplete
                multiple
                options={usersFormat}
                id={'shared-with'}
                value={props.value ? props.value : undefined}
                isOptionEqualToValue={(option, value) => option.value === value.value}
                onChange={(e, newValue) => {
                  props.onChange(newValue);
                }}
                renderInput={(params) => (
                  <TextField {...params}/>
                )}
              />
            );
          }
        }
      ];
    }
  }, [activeUser.group_id, userGroups, users]);

  const getBoards = useCallback(() => {
    if (activeTab === 'shared_with') {
      axios.get(`${process.env.REACT_APP_API_URL}/rpc/hvd_shared_boards?_email=${encodeURIComponent(user.email)}`,
        {
          headers: {
           'ngrok-skip-browser-warning': true  
          }
        })
        .then(res => {
          setBoards(res.data);
        });
    } else {
      axios.get(`${process.env.REACT_APP_API_URL}/custom_boards?created_by=eq.${encodeURIComponent(user.email)}`,{
        headers: {
          'ngrok-skip-browser-warning': true   
        }
      })
        .then(res => {
          setBoards(res.data);
        });
    }

    axios.get(`${process.env.REACT_APP_API_URL}/groups`, {
      headers: {
        'ngrok-skip-browser-warning': true
      }
    })
      .then(res => {
        return setUserGroups(res.data);
      });
  }, [user, activeTab,]);

  useEffect(() => {
    getBoards();
    axios.get(`${process.env.REACT_APP_API_URL}/users`, {
      headers: {
        'ngrok-skip-browser-warning': true 
      }
    })
      .then(res => {
        setUsers(res.data);

        let currentUser = res.data.find((element, index) => {
          let valid = false;

          if (element.email === user.email) {
            valid = true;
          }

          return valid;
        });

        setActiveUser(currentUser);
      });
  }, [getBoards, user]);

  useEffect(() => {
    setColumns(defineColumns(activeTab));
  }, [activeTab, defineColumns]);


  //function for updating the existing row details
  const handleRowUpdate = (newData, oldData, resolve) => {
    // Cloning object and deleting the keys not required on data update.
    let dataToUpdate = structuredClone(newData);
    delete dataToUpdate.tableData;

    // Apply the .trim() method to the "label" value before updating the row data
    dataToUpdate.label = dataToUpdate.label.trim();

    // Exclude the currently edited board name from the array because it can not duplicate its name.
    let savedBoards = boards?.filter( board => board.label !== oldData.label);

    if (!nameValidation({ arr: savedBoards, name: dataToUpdate.label, key: 'label' })) {
      setErrorMessages(["Board name is already in use"]);
      setIserror(true);
      resolve();
      return;
    }

    //validating the data inputs
    let errorList = [];

    if (errorList.length < 1) {
      axios.put(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${newData.uuid}`, dataToUpdate, {
        headers: {
          'ngrok-skip-browser-warning': true
        }
      })
        .then(response => {
          getBoards();
          resolve();
          setIserror(false);
          setErrorMessages([]);
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            setErrorMessages([`Update Failed! ${error.response.data.details}`]);
          }

          setIserror(true);
          resolve();
        })
    } else {
      setErrorMessages(errorList);
      setIserror(true);
      resolve();
    }
  }

  //function for deleting a row
  const handleRowDelete = (oldData, resolve) => {
    if (oldData.created_by === user.email) {
      axios.delete(`${process.env.REACT_APP_API_URL}/custom_boards?uuid=eq.${oldData.uuid}`,
        {
          headers: {
           'ngrok-skip-browser-warning': true
          }
        })
        .then(response => {
          getBoards();
          resolve();
        })
        .catch(error => {
          if (error.response) {
            // Request made and server responded
            setErrorMessages([`Delete failed! ${error.response.data.details}`]);
          }
          setIserror(true);
          resolve();
        })
    } else {
      setErrorMessages(["Delete failed! Boards can only be delete by their creator"]);
      setIserror(true);
      resolve();

    }
  }

  return (
    <LayoutPage
      type = 'crud'
      pageTitle='Custom Boards'
      description='View, update or delete custom boards.'
      customClass='page-crud'
    >
      <>
        <Box className="GroupsButtons" sx={TabsStyles}>
          {
            tabs.map((tab, key) =>
              <Button
                key={key}
                className={`GroupsButtons__item ${key === 0 ? 'active' : ''}`}
                onClick={(e) => {
                  let buttons = document.querySelectorAll('.GroupsButtons__item');
                  buttons.forEach(button => button.classList.remove('active'));
                  e.currentTarget.className += " active";
                  setActiveTab(tab.value);
                  // setColumns(defineColumns(tab.value));
                }}
              >
                {tab.name}
              </Button>
            )
          }
        </Box>
        <MaterialTable
          title="Custom Boards"
          columns={columns}
          data={boards}
          options={{
            headerStyle: { borderBottomColor: '#773dbd', borderBottomWidth: '3px' },
            actionsColumnIndex: -1,
            toolbarButtonAlignment: "left",
            pageSize: 20,
            emptyRowsWhenPaging: false,
            pageSizeOptions: [10, 20, 30, 50]
          }}
          components={{
            Toolbar: props => (
              <MTableToolbar {...props} classes={{ root: "board-toolbar" }} />
            ),
          }}
          editable={
            activeTab !== 'shared_with' ?
              {
                onRowUpdate: (newData, oldData) =>
                  new Promise((resolve) => {
                    handleRowUpdate(newData, oldData, resolve);
                  }),
                onRowDelete: (oldData) =>
                  new Promise((resolve) => {
                    handleRowDelete(oldData, resolve)
                  }),
              } : {}
          }
        />

        <div>
          <Snackbar open={iserror} autoHideDuration={5000} onClose={() => setIserror(false)}>
            <Alert
              sx={{ position: 'fixed', bottom: '10px', left: "5px", zIndex: "1" }}
              severity="error"
              variant="filled"
              onClose={() => setIserror(false)}
              >
              {errorMessages.map((msg, i) => {
                return <div key={i}>{msg}</div>
              })}
            </Alert>
          </Snackbar>  
        </div>
        <ReportButtons boardType={'Groups'} />
      </>
    </LayoutPage>
  );
}

export default CustomBoards;
